import { PaymentDirectiveModule, PromptSaveDirectiveModule } from '@b2b/common/directives';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDataResolver, OrderFormsDataResolver } from '../resolvers';
import { OrdersEditControllerModule } from './controllers/OrdersEditController';
import { CartFormsComponentModule } from '@b2b/views/application/views/cart/components/cart-forms/cart-forms.component';
import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';

export const OrdersEditView = angular
  .module('acme.view.application.orders.edit', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    PaymentDirectiveModule,
    PromptSaveDirectiveModule,
    'acme.common.directive.integer',
    OrdersEditControllerModule,
    CartFormsComponentModule
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.edit',
      url: '/:orderId/edit',
      views: {
        'subview-main': {
          controller: 'OrdersEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Order',
        /** Secure With Permissions **/
        permissions: ['ORDER_UPDATE', 'ACCT_ORDERS_UPDATE'],
      },
      resolve: {
        OrderData: OrderDataResolver(),
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
        OrderFormsData: OrderFormsDataResolver(),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });
  }).name;
